<template>
  <div>
    <bar-manut single-entity="Produto" plural-entity="Produtos" :crud="lCrud" :btn-delete="permissaoExcluir"
      v-on:delete="apiDelete" v-on:closeform="closeForm" v-on:save="handleSave">
    </bar-manut>

    <!-- mensagens de erro -->
    <validation v-if="errmessages.length != 0" :messages="errmessages"></validation>

    <!-- TELA DE CADASTRO SIMPLIFICADA UTILIZADA NA IMPORTACAO DO XML DA NFE -->

    <div id="modal" v-if="formatoTela == 'importacaonfe'">
      <div class="row">
        <form-field ref="codigo" v-model="item.codigo" :metadata="metadata.item.codigo" type="text" col="3" name="codigo"
          id="codigo" :v-errors="errors" v-validate="metadata.item.codigo.validator"
          :disabled="isView || itemComMovimento"></form-field>
        <form-field v-model="item.descricao" type="text" col="12" :metadata="metadata.item.descricao" name="descricao"
          id="descricao" :v-errors="errors" v-validate="metadata.item.descricao.validator"
          :disabled="isView"></form-field>
        <form-field v-model="item.tipoproduto" type="select2" col="12" :metadata="metadata.item.tipoproduto"
          name="tipoproduto" :v-errors="errors" v-validate="metadata.item.tipoproduto.validator" parent="modal"
          :disabled="isView"></form-field>
        <form-field v-model="item.uni" type="select2" col="12" :metadata="metadata.item.uni" name="uni" :v-errors="errors"
          v-validate="metadata.item.uni.validator" parent="modal" :disabled="isView || itemComMovimento"></form-field>
      </div>
      <div class="row">
        <form-field v-model="item.ncm" type="select2" col="12" :metadata="metadata.item.ncm" name="ncm" id="ncm"
          :v-errors="errors" v-validate="metadata.item.ncm.validator" parent="modal" :disabled="isView"></form-field>
        <form-field v-model="item.orimerc" type="select2" col="12" :metadata="metadata.item.orimerc" name="orimerc"
          :v-errors="errors" v-validate="metadata.item.orimerc.validator" parent="modal" :disabled="isView"></form-field>
        <form-field v-model="item.formaaq" type="select" col="12" :metadata="metadata.item.formaaq"
              :disabled="isView"></form-field>
        <form-field v-model="item.codgruest" type="select2" col="12" :metadata="metadata.item.codgruest" name="codgruest"
          :v-errors="errors" v-validate="metadata.item.codgruest.validator" parent="modal"
          :disabled="isView"></form-field>
        <form-field v-model="item.cest" type="number" col="6" :metadata="metadata.item.cest" name="cest"
          :v-errors="errors" v-validate="metadata.item.cest.validator" :disabled="isView"></form-field>
        <form-field v-model="item.codbarras" type="number" col="6" :metadata="metadata.item.codbarras" name="codbarras"
          :v-errors="errors" v-validate="metadata.item.codbarras.validator" :disabled="isView"></form-field>
      </div>
    </div>
    <!-- FIM TELA DE CADASTRO SIMPLIFICADA UTILIZADA NA IMPORTACAO DO XML DA NFE -->


    <!-- TELA DE CADASTRO SIMPLIFICADA UTILIZADA NO FORCA DE VENDAS -->
    <div id="modal" v-if="formatoTela == 'forcaVendas' || isView">
      <div class="default-container">
        <div class="row">
          <form-field ref="codigo" v-model="item.codigo" :metadata="metadata.item.codigo" type="text" col="3"
            name="codigo" id="codigo" :v-errors="errors" v-validate="metadata.item.codigo.validator"
            :disabled="isView || itemComMovimento"></form-field>
          <form-field v-model="item.descricao" type="text" col="12" :metadata="metadata.item.descricao" name="descricao"
            id="descricao" :v-errors="errors" v-validate="metadata.item.descricao.validator"
            :disabled="isView"></form-field>
          <form-field v-model="item.desccomp" type="memo" col="12" :metadata="metadata.item.desccomp" name="desccomp"
            :v-errors="errors" v-validate="metadata.item.desccomp.validator" :disabled="isView"></form-field>
          <!-- <form-field v-model="item.tipoproduto" type="select2" col="6" :metadata="metadata.item.tipoproduto"
                    name="tipoproduto" :v-errors="errors" v-validate="metadata.item.tipoproduto.validator" parent="modal" :disabled="isView"></form-field> -->
          <form-field v-model="item.uni" type="select2" col="6" :metadata="metadata.item.uni" name="uni"
            :v-errors="errors" v-validate="metadata.item.uni.validator" parent="modal"
            :disabled="isView || itemComMovimento"></form-field>
          <form-field v-model="item.qtlotemult" type="value" col="3" :metadata="metadata.item.qtlotemult" :precision="2"
            name="qtlotemult" :v-errors="errors" v-validate="metadata.item.qtlotemult.validator"
            :disabled="isView"></form-field>
        </div>
        <div class="row">
          <form-field v-model="item.pliq" type="value" col="3" :metadata="metadata.item.pliq" name="pliq"
            :v-errors="errors" v-validate="metadata.item.pliq.validator" addon="Kg" :disabled="isView"></form-field>
          <form-field v-model="item.pbru" type="value" col="3" :metadata="metadata.item.pbru" addon="Kg" name="pbru"
            :v-errors="errors" v-validate="metadata.item.pbru.validator" :disabled="isView"></form-field>
          <form-field v-model="item.stitem" :tabindex="1" type="select" col="3" :metadata="metadata.item.stitem"
            name="stitem" :v-errors="errors" v-validate="metadata.item.stitem.validator" :disabled="isView"></form-field>

        </div>
        <div class="row">
          <form-field v-model="item.tipoitem" type="select" col="2" :metadata="metadata.item.tipoitem"
            :disabled="isView"></form-field>
        </div>
        <div class="row">
          <form-field v-model="item.codgruest" type="select2" col="6" :metadata="metadata.item.codgruest" name="codgruest"
            :v-errors="errors" v-validate="metadata.item.codgruest.validator" parent="modal"
            :disabled="isView"></form-field>
          <form-field v-model="item.orimerc" type="select2" col="3" :metadata="metadata.item.orimerc" name="orimerc"
            :v-errors="errors" v-validate="metadata.item.orimerc.validator" parent="modal"
            :disabled="isView"></form-field>
          <form-field v-model="item.formaaq" type="select" col="2" :metadata="metadata.item.formaaq"
              :disabled="isView"></form-field>
          <form-field v-model="item.icmitem" type="select" col="3" :metadata="metadata.item.icmitem"
            :disabled="isView"></form-field>
          <form-field v-model="item.ncm" type="select2" col="6" :metadata="metadata.item.ncm" name="ncm" id="ncm"
            :v-errors="errors" v-validate="metadata.item.ncm.validator" parent="modal" :disabled="isView"></form-field>
          <form-field v-model="item.ipiitem" type="select" col="3" :metadata="metadata.item.ipiitem"
            :disabled="isView"></form-field>
          <form-field v-model="item.aipi" type="value" col="3" :metadata="metadata.item.aipi" :precision="2" name="aipi"
            :v-errors="errors" v-validate="metadata.item.aipi.validator" addon="%" :disabled="isView"></form-field>
          <form-field v-model="item.cest" type="number" col="3" :metadata="metadata.item.cest" name="cest"
            :v-errors="errors" v-validate="metadata.item.cest.validator" :disabled="isView"></form-field>
        </div>
        <div class="row">
          <form-field v-model="item.cuspadrao" type="value" col="3" :metadata="metadata.item.cuspadrao" :precision="2"
            preaddon="R$" name="cuspadrao" :v-errors="errors" v-validate="metadata.item.cuspadrao.validator"
            :disabled="isView"></form-field>
          <!-- <form-field v-model="item.precovenda" type="value" col="4" :metadata="metadata.item.precovenda" :precision="2"
                    name="precovenda" :v-errors="errors" v-validate="metadata.item.precovenda.validator" :disabled="isView"></form-field> -->
        </div>

        <div id="accordion">
          <div class="card">
            <div class="card-header" id="headingOne">
              <h5 class="mb-0">
                <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" :aria-expanded="appLoja ? 'true' : 'false'"
                  aria-controls="collapseOne">
                  Dados da Loja
                </button>
              </h5>
            </div>

            <div id="collapseOne" class="collapse" :class="appLoja ? 'show' : 'hide'" aria-labelledby="headingOne" data-parent="#accordion">
              <div class="card-body">
                <form-field v-model="item.ecommerce" :tabindex="1" type="select" col="3"
                  :metadata="metadata.item.ecommerce" name="stitem" :v-errors="errors"
                  v-validate="metadata.item.ecommerce.validator" :disabled="isView"></form-field>
              </div>
            </div>
          </div>
        </div>

        <!-- GRADE DO PRODUTO -->
        <div v-if="item.tipoitem == 'P'">

          <label-title title="Controle de Grade" class="mt-2"></label-title>
          <div class="row" v-if="!editaGrade && item.codgradel">
            <form-field reg="codgradel" v-model="item.codgradel" type="select2" col="6"
              :metadata="metadata.item.codgradel" :disabled="true" name="codgradel" :v-errors="errors"
              v-validate="metadata.item.codgradel.validator"></form-field>
            <form-field v-model="item.codgradec" type="select2" col="6" :metadata="metadata.item.codgradec"
              :disabled="true" name="codgradec" :v-errors="errors"
              v-validate="metadata.item.codgradec.validator"></form-field>
          </div>
          <div class="row" v-if="!editaGrade">
            <div class="col-md-12 col-12">
              <v-button label="Definir Uma Grade" :nb-btdef="true" :disabled="isView"
                @click="handleHabilitaGrade"></v-button>
            </div>
          </div>
          <div class="row" v-if="editaGrade">
            <form-field ref="codgradel" v-model="item.codgradel" type="select2" col="6"
              :metadata="metadata.item.codgradel" name="codgradel" :v-errors="errors"
              v-validate="metadata.item.codgradel.validator" :disabled="isView"></form-field>
            <form-field v-model="item.codgradec" type="select2" col="6" :metadata="metadata.item.codgradec"
              name="codgradec" :v-errors="errors" v-validate="metadata.item.codgradec.validator"
              :disabled="isView"></form-field>
          </div>
          <div class="row" v-if="editaGrade">
            <div class="col-md-12 col-12">
              <v-button label="Aplicar Grade" title="" :nb-btdef="true" @click="handleAplicaGrade"></v-button>
            </div>
          </div>

          <div>
            <div class="mainbox" v-for="(grade, index) in gradelist" v-bind:key="index">
              <!-- <div v-bind:class="[{ 'mark-red': uni.duplicate }]"></div> -->
              <div class="box">
                <div class="row align-items-center">
                  <div v-if="grade.parametros && grade.parametros.docs && (grade.parametros.docs.length > 0)"
                    class="col-md-1 col-12 text-center">
                    <img :src="grade.parametros.docs[0].img" class="mx-auto d-block img-thumbnail" alt="Logotipo"
                      style="max-width: 45px; max-height: 45px;" @click="handleVincularImagem(grade)">
                  </div>
                  <div v-else class="col-md-1 col-12 text-center">
                    <i class="fa fa-camera mx-auto d-block" style="font-size: 25px; color: silver; cursor: pointer"
                      @click="handleVincularImagem(grade)"></i>
                  </div>
                  <div class="col-md-2 col-12">
                    <span v-if="grade.corlinha" class="current-color"
                      :style="'background-color: ' + grade.corlinha"></span>
                    <span class="lbl-title-produto"> {{ grade.descricaolinha }} </span>
                  </div>
                  <div class="col-md-2 col-12">
                    <span v-if="grade.corcoluna" class="current-color"
                      :style="'background-color: ' + grade.corcoluna"></span>
                    <span class="lbl-title-produto"> {{ grade.descricaocoluna }} </span>
                  </div>
                  <form-field v-model="grade.codbarras" type="text" col="2" :metadata="metadata.item.codbarras"
                    :disabled="isView"></form-field>
                  <div class="col-md-3 col-12">
                    <input-switch type="success" label="Ativo?" v-model="grade.ativo" value-checked="S"
                      value-unchecked="N"></input-switch>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
    <!-- FIM TELA DE CADASTRO SIMPLIFICADA UTILIZADA NO FORCA DE VENDAS -->




    <div class="default-container" v-if="formatoTela == 'normal' || isView">
      <!-- dados do item -->
      <div>
        <div class="row">
          <form-field ref="codigo" v-model="item.codigo" :metadata="metadata.item.codigo" type="text" col="2"
            name="codigo" id="codigo" :v-errors="errors" v-validate="metadata.item.codigo.validator"
            :disabled="isView || itemComMovimento"></form-field>
        </div>
        <div class="row">
          <form-field v-model="item.descricao" type="text" col="6" :metadata="metadata.item.descricao" name="descricao"
            id="descricao" :v-errors="errors" v-validate="metadata.item.descricao.validator"
            :disabled="isView"></form-field>
          <form-field v-model="item.descnf" type="text" col="6" :metadata="metadata.item.descnf" name="descnf"
            :v-errors="errors" v-validate="metadata.item.descnf.validator" :disabled="isView"></form-field>
        </div>
        <div class="row">
          <form-field v-model="item.tipoitem" type="select" col="4" :metadata="metadata.item.tipoitem"
            :disabled="isView"></form-field>
          <form-field v-model="item.tipoproduto" type="select2" col="4" :metadata="metadata.item.tipoproduto"
            name="tipoproduto" :v-errors="errors" v-validate="metadata.item.tipoproduto.validator"
            :disabled="isView"></form-field>
          <form-field v-model="item.stitem" type="select" col="4" :metadata="metadata.item.stitem" name="stitem"
            :v-errors="errors" v-validate="metadata.item.stitem.validator" :disabled="isView"></form-field>
        </div>
        <div v-if="item.tipoitem == 'P'" class="row">
          <form-field v-model="item.tipoestoque" type="select" col="4" :metadata="metadata.item.tipoestoque"
            name="tipoestoque" :v-errors="errors" v-validate="metadata.item.tipoestoque.validator"
            :disabled="isView"></form-field>
          <form-field v-model="item.uni" type="select2" col="4" :metadata="metadata.item.uni" name="uni"
            :v-errors="errors" v-validate="metadata.item.uni.validator" :add-button="true"
            @clickAdd="handleIncluir('uni')" :disabled="isView || itemComMovimento"></form-field>
        </div>
        <div class="row">
          <form-field v-if="item.tipoitem == 'P'" v-model="item.pliq" type="value" col="2" :metadata="metadata.item.pliq"
            name="pliq" :v-errors="errors" v-validate="metadata.item.pliq.validator" :disabled="isView"></form-field>
          <form-field v-if="item.tipoitem == 'P'" v-model="item.pbru" type="value" col="2" :metadata="metadata.item.pbru"
            name="pbru" :v-errors="errors" v-validate="metadata.item.pbru.validator" :disabled="isView"></form-field>
          <form-field v-model="item.cuspadrao" type="value" col="4" :metadata="metadata.item.cuspadrao" :precision="2"
            name="cuspadrao" :v-errors="errors" v-validate="metadata.item.cuspadrao.validator"
            :disabled="isView"></form-field>
          <form-field v-model="item.precovenda" type="value" col="4" :metadata="metadata.item.precovenda" :precision="2"
            name="precovenda" :v-errors="errors"
            :disabled="isView"></form-field>
        </div>
        <div v-if="item.tipoitem == 'P'" class="row">
          <form-field v-model="item.codbarras" type="number" col="4" :metadata="metadata.item.codbarras" name="codbarras"
            :v-errors="errors" v-validate="metadata.item.codbarras.validator" :disabled="isView"></form-field>
          <form-field v-model="item.codbarrastrib" type="number" col="4" :metadata="metadata.item.codbarrastrib"
            name="codbarrastrib" :v-errors="errors" v-validate="metadata.item.codbarrastrib.validator"
            :disabled="isView"></form-field>
          <form-field v-model="item.codgruest" type="select2" col="4" :metadata="metadata.item.codgruest" name="codgruest"
            :v-errors="errors" v-validate="metadata.item.codgruest.validator" :add-button="true"
            @clickAdd="handleIncluir('gruest')" :disabled="isView"></form-field>
        </div>

      </div>

      <!-- IMPOSTOS -->

      <div v-if="item.tipoitem == 'S'">
        <label-title title="Serviços" class="mb-2 mt-2"></label-title>
        <div class="row">
          <form-field v-model="item.issitem" type="select" col="4" :metadata="metadata.item.issitem" name="issitem"
            :v-errors="errors" v-validate="metadata.item.issitem.validator" :disabled="isView"></form-field>

          <form-field v-model="item.cservico" type="text" col="4" :metadata="metadata.item.cservico" name="cservico"
            :v-errors="errors" v-validate="metadata.item.cservico.validator" :disabled="isView"></form-field>
          <form-field v-model="item.cservmun" type="text" col="4" :metadata="metadata.item.cservmun" name="cservmun"
            :v-errors="errors" v-validate="metadata.item.cservmun.validator" :disabled="isView"></form-field>

          <!-- <form-field v-model="item.indiss" type="select2" col="2" :metadata="metadata.item.indiss" -->
          <!--     name="indiss" :v-errors="errors" v-validate="metadata.item.indiss.validator" :disabled="isView"></form-field> -->

          <!-- <form-field v-model="item.nrprociss" type="text" col="2" :metadata="metadata.item.nrprociss" -->
          <!--     v-if="item.indiss=='6'||item.indiss=='7'" -->
          <!--     name="nrprociss" :v-errors="errors" v-validate="metadata.item.nrprociss.validator" :disabled="isView"></form-field> -->

          <!-- <form-field v-model="item.incentfiscaliss" type="select" col="2" :metadata="metadata.item.incentfiscaliss" -->
          <!--     v-if="item.indiss=='6'||item.indiss=='7'" -->
          <!--     name="incentfiscaliss" :v-errors="errors" v-validate="metadata.item.incentfiscaliss.validator" :disabled="isView"></form-field> -->
        </div>
        <div class="row">
          <form-field v-model="item.cnae" type="text" col="4" :metadata="metadata.item.cnae" name="cnae"
            :v-errors="errors" v-validate="metadata.item.cnae.validator" :disabled="isView"></form-field>
          <form-field v-model="item.aiss" type="value" col="4" :metadata="metadata.item.aiss" name="aiss"
            :v-errors="errors" v-validate="metadata.item.aiss.validator" :disabled="isView"></form-field>
          <form-field v-model="item.retiss" type="select" col="4" :metadata="metadata.item.retiss"
            :disabled="isView"></form-field>
          <form-field v-model="item.descontariss" type="select" col="4" :metadata="metadata.item.descontariss"
            :disabled="isView"></form-field>
        </div>
        <div class="row">
          <form-field v-model="item.airrf" type="value" col="4" :metadata="metadata.item.airrf" name="airrf"
            :v-errors="errors" v-validate="metadata.item.airrf.validator" :disabled="isView"></form-field>
          <form-field v-model="item.obs_ir" type="text" col="4" :metadata="metadata.item.obs_ir" name="obs_ir"
            :v-errors="errors" v-validate="metadata.item.obs_ir.validator" :disabled="isView"></form-field>
          <form-field v-model="item.descontarir" type="select" col="4" :metadata="metadata.item.descontarir"
            :disabled="isView"></form-field>

        </div>

        <div class="row">
          <form-field v-model="item.acsll" type="value" col="4" :metadata="metadata.item.acsll" name="acsll"
            :v-errors="errors" v-validate="metadata.item.acsll.validator" :disabled="isView"></form-field>
          <form-field v-model="item.reter_csllpiscofins" type="select" col="4"
            :metadata="metadata.item.reter_csllpiscofins" :disabled="isView"></form-field>
          <form-field v-model="item.reter_inss" type="select" col="4" :metadata="metadata.item.reter_inss"
            :disabled="isView"></form-field>
        </div>

      </div>

      <div v-if="item.tipoitem == 'P'">
        <label-title title="Dimensão" class="mt-2"></label-title>
        <div class="row">
          <form-field v-model="item.comprimento" type="number" col="3" :metadata="metadata.item.comprimento"
            name="comprimento" :v-errors="errors" v-validate="metadata.item.comprimento.validator"
            :disabled="isView"></form-field>
          <form-field v-model="item.largura" type="number" col="3" :metadata="metadata.item.largura" name="largura"
            :v-errors="errors" v-validate="metadata.item.largura.validator" :disabled="isView"></form-field>
          <form-field v-model="item.espessura" type="number" col="3" :metadata="metadata.item.espessura" name="espessura"
            :v-errors="errors" v-validate="metadata.item.espessura.validator" :disabled="isView"></form-field>
        </div>

        <label-title title="Informações Para Faturamento" class="mt-2"></label-title>
        <div class="row">
          <form-field v-model="item.ncm" type="select2" col="6" :metadata="metadata.item.ncm" name="ncm" id="ncm"
            :v-errors="errors" v-validate="metadata.item.ncm.validator" :disabled="isView"></form-field>
          <form-field v-model="item.exncm" type="number" col="2" :metadata="metadata.item.exncm" name="exncm"
            :v-errors="errors" v-validate="metadata.item.exncm.validator" :disabled="isView"></form-field>
        </div>
        <div class="row">
          <form-field v-model="item.ipiitem" type="select" col="2" :metadata="metadata.item.ipiitem"
            :disabled="isView"></form-field>
          <form-field v-if="item.ipiitem == 'T'" v-model="item.aipi" type="value" col="2" :metadata="metadata.item.aipi"
            :precision="2" name="aipi" :v-errors="errors" v-validate="metadata.item.aipi.validator"
            :disabled="isView"></form-field>
          <form-field v-if="item.ipiitem == 'T'" v-model="item.ripi" type="value" col="2" :metadata="metadata.item.ripi"
            :precision="2" name="ripi" :v-errors="errors" v-validate="metadata.item.ripi.validator"
            :disabled="isView"></form-field>
          <form-field v-if="item.ipiitem == 'T'" v-model="item.pautaipi" type="value" col="2"
            :metadata="metadata.item.pautaipi" :precision="2" name="pautaipi" :v-errors="errors"
            v-validate="metadata.item.pautaipi.validator" :disabled="isView"></form-field>
          <form-field v-model="item.escalaprod" type="select" col="2" :metadata="metadata.item.escalaprod"
            :disabled="isView"></form-field>
          <form-field v-model="item.cnpjfab" type="text" col="2" :metadata="metadata.item.cnpjfab"
           v-if="item.escalaprod == 'N'" name="cnpjfab" :v-errors="errors" v-validate="metadata.item.cnpjfab.validator"
           :disabled="isView"></form-field>          <form-field v-model="item.canp" type="number" col="2" :metadata="metadata.item.canp" name="canp"
            :v-errors="errors" v-validate="metadata.item.canp.validator" :disabled="isView"></form-field>
        </div>
        <div class="row">
          <form-field v-model="item.orimerc" type="select2" col="4" :metadata="metadata.item.orimerc" name="orimerc"
            :v-errors="errors" v-validate="metadata.item.orimerc.validator" :disabled="isView"></form-field>
        </div>
        <div class="row">
          <form-field v-model="item.icmitem" type="select" col="4" :metadata="metadata.item.icmitem"
            :disabled="isView"></form-field>
          <form-field v-if="item.icmitem == 'T' || item.icmitem == 'R' || item.icmitem == 'O'" v-model="item.aicm"
            type="value" col="2" :metadata="metadata.item.aicm" :precision="2" name="aicm" :v-errors="errors"
            v-validate="metadata.item.aicm.validator" :disabled="isView"></form-field>
          <form-field v-model="item.cest" type="number" col="2" :metadata="metadata.item.cest" name="cest"
            :v-errors="errors" v-validate="metadata.item.cest.validator" :disabled="isView"></form-field>
          <!-- <form-field v-model="item.issitem" type="select" col="2" :metadata="metadata.item.issitem" :disabled="isView"></form-field> -->
        </div>
        <div class="row">
          <form-field v-model="item.stpis" type="select2" col="4" :metadata="metadata.item.stpis" name="stpis"
            :v-errors="errors" v-validate="metadata.item.stpis.validator"
            :select2="{ entity: 'stpiscofins/saidas', minlength: 0 }" :disabled="isView"></form-field>

          <form-field v-model="item.apis" type="value" col="2" :metadata="metadata.item.apis" :precision="2"
            v-if="item.stpis == '01' || item.stpis == '02'" name="apis" :v-errors="errors"
            v-validate="metadata.item.apis.validator" :disabled="isView"></form-field>

          <form-field v-model="item.rpis" type="value" col="2" :metadata="metadata.item.rpis" :precision="2"
            v-if="item.stpis == '01' || item.stpis == '02'" name="rpis" :v-errors="errors"
            v-validate="metadata.item.rpis.validator" :disabled="isView"></form-field>

          <form-field v-model="item.pautapis" type="value" col="2" :metadata="metadata.item.pautapis" :precision="2"
            v-if="item.stpis == '03'" name="pautapis" :v-errors="errors" v-validate="metadata.item.pautapis.validator"
            :disabled="isView"></form-field>
        </div>
        <div class="row">
          <form-field v-model="item.stcofins" type="select2" col="4" :metadata="metadata.item.stcofins" name="stcofins"
            :v-errors="errors" v-validate="metadata.item.stcofins.validator"
            :select2="{ entity: 'stpiscofins/saidas', minlength: 0 }" :disabled="isView"></form-field>

          <form-field v-model="item.acofins" type="value" col="2" :metadata="metadata.item.acofins" :precision="2"
            v-if="item.stcofins == '01' || item.stcofins == '02'" name="acofins" :v-errors="errors"
            v-validate="metadata.item.acofins.validator" :disabled="isView"></form-field>

          <form-field v-model="item.rcofins" type="value" col="2" :metadata="metadata.item.rcofins" :precision="2"
            v-if="item.stcofins == '01' || item.stcofins == '02'" name="rcofins" :v-errors="errors"
            v-validate="metadata.item.rcofins.validator" :disabled="isView"></form-field>

          <form-field v-model="item.pautacofins" type="value" col="2" :metadata="metadata.item.pautacofins" :precision="2"
            v-if="item.stcofins == '03'" name="pautacofins" :v-errors="errors"
            v-validate="metadata.item.pautacofins.validator" :disabled="isView"></form-field>
        </div>
        <div class="row" v-if="informaFCI">
          <form-field v-model="item.nfci" type="text" col="4" :metadata="metadata.item.nfci" name="nfci"
            :v-errors="errors" v-validate="metadata.item.nfci.validator" :disabled="isView"></form-field>

          <form-field v-model="item.fciconteudo" type="value" col="2" :metadata="metadata.item.fciconteudo" :precision="2"
            name="fciconteudo" :v-errors="errors" v-validate="metadata.item.fciconteudo.validator"
            :disabled="isView"></form-field>

          <form-field v-model="item.fciparcela" type="value" col="2" :metadata="metadata.item.fciparcela" :precision="2"
            name="fciparcela" :v-errors="errors" v-validate="metadata.item.fciparcela.validator"
            :disabled="isView"></form-field>

          <form-field v-model="item.fcivenda" type="value" col="2" :metadata="metadata.item.fcivenda" :precision="2"
            name="fcivenda" :v-errors="errors" v-validate="metadata.item.fcivenda.validator"
            :disabled="isView"></form-field>
        </div>

      </div>

      <!-- ESTOQUE -->

      <!-- somente itens com controle de estoque -->
      <div v-if="item.tipoitem == 'P'">
        <div v-if="!showInfEst" class="mt-2 mb-2">
          <a href="javascript:void(0);" @click="showInfEst = true" :tabindex="1"><i class="fa fa-caret-down"
              aria-hidden="true"></i> Exibir dados de estoque</a>
        </div>
        <div v-if="showInfEst">
          <label-title title="Informações Para Controle de Estoque" class="mb-2 mt-2"></label-title>
          <div class="row">
            <form-field v-model="item.coddeposito" type="select2" col="4" :metadata="metadata.item.coddeposito"
              name="coddeposito" :v-errors="errors" v-validate="metadata.item.coddeposito.validator" :add-button="true"
              @clickAdd="handleIncluir('depo')" :disabled="isView"></form-field>

            <form-field v-model="item.controlalocal" type="select" col="2" :metadata="metadata.item.controlalocal"
              :disabled="isView"></form-field>

            <!-- <form-field v-model="item.codlocal" type="text" col="2" :metadata="metadata.item.codlocal"
                        name="codlocal" :v-errors="errors" v-validate="metadata.item.codlocal.validator" :disabled="isView"></form-field> -->

            <form-field v-model="item.qtemb" type="value" col="2" :metadata="metadata.item.qtemb" :precision="2"
              name="qtemb" :v-errors="errors" v-validate="metadata.item.qtemb.validator" :disabled="isView"></form-field>

            <form-field v-model="item.qtmin" type="value" col="2" :metadata="metadata.item.qtmin" :precision="2"
              name="qtmin" :v-errors="errors" v-validate="metadata.item.qtmin.validator" :disabled="isView"></form-field>

            <form-field v-model="item.qtpontopedido" type="value" col="2" :metadata="metadata.item.qtpontopedido"
              :precision="2" name="qtpontopedido" :v-errors="errors" v-validate="metadata.item.qtpontopedido.validator"
              :disabled="isView"></form-field>

            <form-field v-model="item.qtloteeco" type="value" col="2" :metadata="metadata.item.qtloteeco" :precision="2"
              name="qtloteeco" :v-errors="errors" v-validate="metadata.item.qtloteeco.validator"
              :disabled="isView"></form-field>

            <form-field v-model="item.qtlotemult" type="value" col="2" :metadata="metadata.item.qtlotemult" :precision="2"
              name="qtlotemult" :v-errors="errors" v-validate="metadata.item.qtlotemult.validator"
              :disabled="isView"></form-field>

            <form-field v-model="item.qtlotemin" type="value" col="2" :metadata="metadata.item.qtlotemin" :precision="2"
              name="qtlotemin" :v-errors="errors" v-validate="metadata.item.qtlotemin.validator"
              :disabled="isView"></form-field>

            <form-field v-model="item.qtlotemax" type="value" col="2" :metadata="metadata.item.qtlotemax" :precision="2"
              name="qtlotemax" :v-errors="errors" v-validate="metadata.item.qtlotemax.validator"
              :disabled="isView"></form-field>

            <form-field v-model="item.qtperda" type="value" col="2" :metadata="metadata.item.qtperda" :precision="2"
              name="qtperda" :v-errors="errors" v-validate="metadata.item.qtperda.validator"
              :disabled="isView"></form-field>

            <form-field v-model="item.fatorrefugo" type="value" col="2" :metadata="metadata.item.fatorrefugo"
              :precision="2" name="fatorrefugo" :v-errors="errors" v-validate="metadata.item.fatorrefugo.validator"
              :disabled="isView"></form-field>

            <form-field v-model="item.tolerancia" type="value" col="2" :metadata="metadata.item.tolerancia" :precision="2"
              name="tolerancia" :v-errors="errors" v-validate="metadata.item.tolerancia.validator"
              :disabled="isView"></form-field>

            <form-field v-model="item.temporepos" type="number" col="2" :metadata="metadata.item.temporepos"
              name="temporepos" :v-errors="errors" v-validate="metadata.item.temporepos.validator"
              :disabled="isView"></form-field>
          </div>
        </div>
      </div>
      <div class="my-2">
        <label-title title="Dimensão"></label-title>
        <div class="row py-2">
          <div class="col-md-12 mb-3">
            <warnings :messages="['Configure aqui os atributos adicionais do item, descrição complementar, ficha técnica, entre outros assuntos importantes.']"></warnings>
          </div>
          <div class="col-md-12 mb-3">
            <v-button label="Novo Atributo" :tabindex="1" :disabled="isView"
              @click="handleNewAtributo"></v-button>
          </div>
          <div class="col-md-12 d-flex align-items-center" v-for="(atributo, i) in atributos.loja.complementos_descricao"
            :key="i">
            <div class="col-1 row justify-content-start py-1">
              <i :class="'border text-secondary p-2 fa' + ' ' + atributo.icone" style="font-size:18px"
                v-if="atributo.icone"></i>
              <small class="text-secondary" v-else>Não informado</small>
            </div>
            <form-field v-model="atributo.titulo" type="text" label="Titulo" col="4" :disabled="true"></form-field>
            <i class="fa" :class="atributo.ativo ? 'fa-check text-success mr-2' : 'fa-ban text-danger mr-2'"></i>
            <button class="btn btn-secondary" title="Configurar Página " @click="handleEditAtributo(i)"><i
                class="fa fa-cog"></i></button>
            <button class="btn btn-outline text-secondary ml-1" title="Deletar" @click="handleDeleteAtributo(i)"><i
                class="fa fa-trash" style="font-size:17px"></i></button>
          </div>
        </div>
      </div>

      <!---->
      <div class="nb-modal-scrollable" v-if="showAtributo">
        <div class="container nb-modal-scrollable-container nb-email-container">
          <div class="nb-modal-header">
            <h5>Novo Atributo</h5>
            <button type="button" class="close" :tabindex="1" @click="closeModalAtributo" data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="nb-modal-scrollable-body">
            <div class="container">
              <div class="row d-flex align-items-center">
                <div class="col-5 d-flex flex-column">
                  <span class="lbl-edit">Ícone</span>
                  <div class="d-inline mb-3 btn-icon">
                    <button class="p-2 mr-2 border text-secondary btn-icon" :class="icon.selected ? 'iconSelected' : ''"
                      v-for="(icon, i) in iconOptions" :key="i" @click="handleSelectIcon(icon)">
                      <i :class="'fa ' + icon.text" style="font-size:16px"></i>
                    </button>
                  </div>
                </div>
                <form-field v-model="atributo.titulo" type="text" label="Título" col="7"></form-field>
              </div>
              <div class="row">
              </div>
              <div class="row">
                <div class="col-md-12">
                  <wysiwyg v-model="atributo.conteudo" />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-12">
                  <input-checkbox v-model="atributo.ativo" label="Ativo" :value-checked="true"
                    :value-unchecked="false"></input-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div class="nb-modal-scrollable-footer mt-4">
            <v-button ref="btnConfirm" label="Salvar" title="" :nb-btdef="true" @click="handleSaveAtributo()"></v-button>
            <v-button ref="btnClose" label="Cancelar" title="" @click="closeModalAtributo()"></v-button>
          </div>
        </div>
      </div>

      <!-- Observações do Produto -->


      <div v-if="item.tipoitem == 'P'">
        <div v-if="!showCompItens && !isView" class="mt-2 mb-2">
          <a href="javascript:void(0);" :tabindex="1" @click="showCompItens = true"><i class="fa fa-caret-down"
              aria-hidden="true"></i> Exibir complementos do item</a>
        </div>
        <div class="my-2" v-if="showCompItens || isView">
          <label-title title="Complementos do Produto"></label-title>
          <div class="row py-2">
            <div class="col-md-12 mb-3">
              <span class="lbl-edit">
                Configure aqui as observações e/ou complementos adicionais do produto.
              </span>
            </div>
            <div class="col-md-12 mb-3">
              <v-button label="Novo Complemento" :disabled="isView"
                @click="handleNewComplemento"></v-button>
            </div>
            <template v-if="complementos.length">
              <div class="col-md-12 d-flex align-items-center" v-for="(complemento, i) in complementos" :key="i">
                <form-field v-model="complemento.descricao" type="text" label="Descrição" col="4"></form-field>
                <span style="margin-top: 10px">
                  <input-checkbox v-model="complemento.ativo" label="Ativo" :value-checked="true"
                    :value-unchecked="false"></input-checkbox>
                </span>
                <button class="btn btn-outline text-secondary m-1" title="Deletar" @click="handleDeleteComp(i)">
                  <i class="fa fa-trash" style="font-size:17px; margin-top: 10px"></i>
                </button>
              </div>
            </template>
          </div>
        </div>
      </div>


      <!-- prods perigosos -->
      <div v-if="item.tipoitem == 'P'">
        <div v-if="!showProdPerigoso && !isView" class="mt-2 mb-2">
          <a href="javascript:void(0);" :tabindex="1" @click="showProdPerigoso = true"><i class="fa fa-caret-down"
              aria-hidden="true"></i> Exibir dados de produtos perigosos</a>
        </div>
        <div v-if="showProdPerigoso || isView">
          <label-title title="Produtos Perigosos" class="mb-2 mt-2"></label-title>
          <div class="row">
            <form-field v-model="item.nronu" type="text" col="2" :metadata="metadata.item.nronu" name="nronu"
              :v-errors="errors" v-validate="metadata.item.nronu.validator" :disabled="isView"></form-field>

            <form-field v-model="item.classerisco" type="text" col="2" :metadata="metadata.item.classerisco"
              name="classerisco" :v-errors="errors" v-validate="metadata.item.classerisco.validator"
              :disabled="isView"></form-field>

            <form-field v-model="item.classifrisco" type="text" col="2" :metadata="metadata.item.classifrisco"
              name="classifrisco" :v-errors="errors" v-validate="metadata.item.classifrisco.validator"
              :disabled="isView"></form-field>

            <form-field v-model="item.grupoembalagem" type="text" col="2" :metadata="metadata.item.grupoembalagem"
              name="grupoembalagem" :v-errors="errors" v-validate="metadata.item.grupoembalagem.validator"
              :disabled="isView"></form-field>

            <form-field v-model="item.qtlimitada" type="value" col="2" :metadata="metadata.item.qtlimitada" :precision="2"
              name="qtlimitada" :v-errors="errors" v-validate="metadata.item.qtlimitada.validator"
              :disabled="isView"></form-field>

            <form-field v-model="item.descembarque" type="text" col="2" :metadata="metadata.item.descembarque"
              name="descembarque" :v-errors="errors" v-validate="metadata.item.descembarque.validator"
              :disabled="isView"></form-field>
          </div>
        </div>
      </div>

      <div v-if="item.tipoitem == 'P'">
        <div v-if="!showOutrasInf && !isView" class="mt-2 mb-2">
          <a href="javascript:void(0);" :tabindex="1" @click="showOutrasInf = true"><i class="fa fa-caret-down"
              aria-hidden="true"></i> Exibir outras informações</a>
        </div>
        <div v-if="showOutrasInf || isView">
          <label-title title="Outras Informações" class="mb-2 mt-2"></label-title>
          <div class="row">
            <form-field v-model="item.desccomp" type="memo" col="8" :metadata="metadata.item.desccomp" name="desccomp"
              :v-errors="errors" v-validate="metadata.item.desccomp.validator" :disabled="isView"></form-field>
          </div>
          <!-- <div class="row">
                    <form-field v-model="item.revisaoproduto" type="number" col="2" :metadata="metadata.item.revisaoproduto"
                        name="revisaoproduto" :v-errors="errors" v-validate="metadata.item.revisaoproduto.validator" :disabled="isView"></form-field>
                    <form-field v-model="item.codtpcarga" type="select2" col="4" :metadata="metadata.item.codtpcarga"
                        name="codtpcarga" :v-errors="errors" v-validate="metadata.item.codtpcarga.validator" :disabled="isView"></form-field>
                </div> -->
          <form-field v-model="item.ecommerce" :tabindex="1" type="select" col="3" :metadata="metadata.item.ecommerce"
            name="stitem" :v-errors="errors" v-validate="metadata.item.ecommerce.validator"
            :disabled="isView"></form-field>
        </div>
      </div>

      <!-- TABELA DE PAUTA -->
      <div v-if="item.tipoitem == 'P'">
        <!-- <div v-if="!showPauta" class="mt-2 mb-2">
                <a href="javascript:void(0);" @click="showPauta = true"><i class="fa fa-caret-down" aria-hidden="true"></i> Exibir pauta de ICMS </a>
            </div> -->
        <div v-if="showPauta && isView">
          <label-title title="Tabela de Pauta ICMS" class="mb-2 mt-2"></label-title>
          <div>
            <div class="mainbox" v-for="(pauta, index) in pauta" :key="index">
              <div v-bind:class="[{ 'mark-red': pauta.duplicate }]"></div>
              <div class="box">
                <div class="col" v-if="pauta.duplicate">
                  <small class="error">Estado duplicado</small>
                </div>
                <div class="row align-items-center">
                  <form-field v-model="pauta.ufdest" type="select2" col="4" :metadata="metadata.pauta.ufdest"
                    :disabled="isView"></form-field>
                  <form-field v-model="pauta.pautaicm" type="value" col="2" :metadata="metadata.pauta.pautaicm"
                    :precision="2" :disabled="isView"></form-field>
                  <form-field v-model="pauta.pautaicmst" type="value" col="2" :metadata="metadata.pauta.pautaicmst"
                    :precision="2" :disabled="isView"></form-field>
                  <div class="col-md-2 col-2">
                    <v-button label="" title="Excluir Pauta" icon="fa-trash" @click="handleDeletePauta(index)"></v-button>
                  </div>
                </div>
              </div>
            </div> <!-- mainbox -->
            <div class="row">
              <div class="col-md-12 col-12">
                <v-button label="Adicionar Pauta" title="" :nb-btdef="true" @click="handleAdicionaPauta"></v-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- UNIDADES DE MEDIDA -->
      <div v-if="item.tipoitem == 'P'">
        <div v-if="!showDadosUni && !isView" class="mt-2 mb-2">
          <a href="javascript:void(0);" :tabindex="1" @click="showDadosUni = true"><i class="fa fa-caret-down"
              aria-hidden="true"></i> Exibir unidades de medida adicionais </a>
        </div>
        <div class="pb-3" v-if="showDadosUni || isView">
          <label-title title="Outras Unidades de Medida" class="mb-2 mt-2"></label-title>
          <div class="d-flex" v-for="(uni, index) in itemum" :key="index">
            <div style="height: 15% !important;" class="ml-n2" :class="[{ 'mark-red': uni.duplicate || uni.validate }]">
            </div>
            <div class="box ml-1">
              <div class="col" v-if="uni.duplicate">
                <small class="error ml-n3">Unidade de Medida duplicada</small>
              </div>
              <div class="col" v-if="uni.validate">
                <small class="error ml-n3">{{ uni.validate }}</small>
              </div>
              <div class="row align-items-center">
                <form-field v-model="uni.uni" type="select2" col="4" :metadata="metadata.itemum.uni"
                  :disabled="isView"></form-field>
                <form-field v-model="uni.fatoruni" type="value" col="2" :metadata="metadata.itemum.fatoruni"
                  :precision="6" :disabled="isView"></form-field>
                <div class="col-md-2 col-2">
                  <v-button label="" title="Excluir Unidade de Medida" icon="fa-trash"
                    @click="handleDeleteUni(index)"></v-button>
                </div>
              </div>
            </div>
          </div> <!-- mainbox -->
          <div class="row">
            <div class="col-md-12 col-12">
              <v-button label="Adicionar Unidade de Medida" title="" :nb-btdef="true" :disabled="isView"
                @click="handleAdicionaUni"></v-button>
            </div>
          </div>
        </div>
      </div>


      <!-- INSERÇÃO DE PRODUTOS DO KIT -->
      <div v-if="item.tipoitem == 'P'">
        <div v-if="!showKitForm && !isView" class="mt-2 3">
          <a href="javascript:void(0);" :tabindex="1" @click="showKitForm = true"><i class="fa fa-caret-down"
              aria-hidden="true"></i> Exibir itens do Kit </a>
        </div>
        <div class="pb-3" v-if="showKitForm || isView">
          <label-title title="'Itens do Kit" class="mb-2 mt-2"></label-title>
          <div class="d-flex" v-for="(item, index) in itemkit" :key="index">
            <div style="height: 15% !important;" class="ml-n2" :class="[{ 'mark-red': item.duplicate || item.validate }]">
            </div>
            <div class="box ml-1">
              <div class="col" v-if="item.duplicate">
                <small class="error ml-n3">Item duplicado</small>
              </div>
              <div class="col" v-if="item.validate">
                <small class="error ml-n3">{{ item.validate }}</small>
              </div>
              <div class="row align-items-center">
                <form-field v-model="item.coditem" type="select2" label="Selecione um item" col="4"
                  :metadata="metadata.pedvit.coditem" @input="hasGrid(item.coditem)" :disabled="true"></form-field>
                <form-field v-model="item.qt" type="number" label="Quantidade" col="2" :disabled="true"></form-field>
                <!-- <div class="col-md-2 col-2"> -->
                <!--     <v-button label="" title="Excluir item do Kit" icon="fa-trash" @click="handleDeleteItem(index)"></v-button> -->
                <!-- </div> -->
              </div>
              <div class="row">
                <form-field v-model="item.coditemgrade" type="select2" col="4" v-if="item.hasGrid && item.hasGrid === 'S'"
                  :select2="{ entity: '/grades/item/' + item.coditem, minlength: 0 }" :disabled="true"></form-field>
              </div>
            </div>
          </div>
          <!-- <div class="row"> -->
          <!--     <div class="col-md-12 col-12"> -->
          <!--         <v-button label="Adicionar Item ao Kit" title="" :nb-btdef="true" @click="handleAdicionaItem"></v-button> -->
          <!--     </div> -->
          <!-- </div> -->
        </div>
      </div>

      <!-- MARKETPLACE -->

      <div v-if="!showDadosMarketplace && !isView && item.tipoitem == 'P'" class="mt-2 mb-2">
        <a href="javascript:void(0);" :tabindex="1" @click="showDadosMarketplace = true"><i class="fa fa-caret-down"
            aria-hidden="true"></i> Exibir dados do marketplace </a>
      </div>
      <div v-if="((showDadosMarketplace || isView) && item.tipoitem == 'P')">
        <label-title title="Marketplace" class="mb-2 mt-2"></label-title>
        <div class="row">
          <form-field v-model="item.titulomkt" type="text" col="12" :metadata="metadata.item.titulomkt" name="titulomkt"
            :v-errors="errors" v-validate="metadata.item.titulomkt.validator" case="normal"
            :disabled="isView"></form-field>
        </div>
        <div class="row">
          <form-field v-model="item.marcamkt" type="text" col="6" :metadata="metadata.item.marcamkt" name="marcamkt"
            :v-errors="errors" v-validate="metadata.item.marcamkt.validator" case="normal"
            :disabled="isView"></form-field>
          <form-field v-model="item.planomktml" :tabindex="1" type="select" col="6" :metadata="metadata.item.planomktml"
            :disabled="isView"></form-field>
        </div>
        <div class="row">
          <form-field v-model="item.modoenviomlmkt" :tabindex="1" type="select" col="6"
            :metadata="metadata.item.modoenviomlmkt" :disabled="isView"></form-field>
          <form-field v-model="item.localpickupmlmkt" :tabindex="1" type="select" col="6"
            :metadata="metadata.item.localpickupmlmkt" :disabled="isView"></form-field>
        </div>
        <div class="row">
          <form-field v-model="item.descricaomkt" type="memo" col="12" :metadata="metadata.item.descricaomkt"
            name="descricaomkt" :v-errors="errors" v-validate="metadata.item.descricaomkt.validator" case="normal"
            :disabled="isView"></form-field>
        </div>

        <label-title title="Categorias Marketplace" class="mb-2 mt-2"></label-title>
        <div class="mainbox" v-for="(catmkt, index) in itemcatmkt" v-bind:key="index">
          <div v-bind:class="[{ 'mark-red': catmkt.duplicate }]"></div>
          <div class="box">
            <div class="col" v-if="catmkt.duplicate">
              <small class="error">Categoria Marketplace duplicada</small>
            </div>
            <div class="row align-items-center">
              <form-field v-model="catmkt.codcatmkt" type="select2" col="4" :metadata="metadata.itemcatmkt.codcatmkt"
                @input="handleCatmkt" :disabled="isView"></form-field>
              <div class="col-md-2 col-2">
                <v-button label="" title="Excluir Categoria Marketplace" icon="fa-trash"
                  @click="handleDeleteCatmkt(index)"></v-button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-12">
            <v-button label="Adicionar Categoria Marketplace" title="" :disabled="isView" :nb-btdef="true"
              @click="handleAdicionaCatmkt"></v-button>
          </div>
        </div>
      </div>

      <div v-if="showDadosAtributosMercadoLivre">
        <label-title title="Atributos Mercado Livre" class="mb-2 mt-2"></label-title>

        <div class="mainbox" v-for="(atribmkt, index) in categoriesAttributes" v-bind:key="index">
          <div class="box" v-if="atribmkt.value_type == 'string'">
            <div class="row align-items-center">
              <form-field v-model="atribmkt.value_name" type="text" col="4" :metadata="atribmkt.metadata"
                :disabled="isView"></form-field>
            </div>
          </div>
          <div class="box" v-if="atribmkt.value_type == 'number'">
            <div class="row align-items-center">
              <form-field v-model="atribmkt.value_name" type="value" col="4" :precision="2" :v-errors="errors"
                :metadata="atribmkt.metadata" :disabled="isView"></form-field>
            </div>
          </div>
          <div class="box" v-if="atribmkt.value_type == 'list'">
            <div class="row align-items-center">
              <form-field v-model="atribmkt.value_id" :tabindex="1" type="select" col="4" :metadata="atribmkt.metadata"
                :disabled="isView"></form-field>
            </div>
          </div>
          <div class="box" v-if="atribmkt.value_type == 'boolean'">
            <div class="row align-items-center">
              <form-field v-model="atribmkt.value_id" :tabindex="1" type="select" col="4" :metadata="atribmkt.metadata"
                :disabled="isView"></form-field>
            </div>
          </div>
          <div class="box" v-if="atribmkt.value_type == 'number_unit'">
            <div class="row align-items-center">
              <form-field v-model="atribmkt.value_name" type="value" col="4" :precision="2" :v-errors="errors"
                :metadata="atribmkt.metadata" :disabled="isView"></form-field>
              <form-field v-model="atribmkt.value_id" :tabindex="1" type="select" col="4"
                :metadata="atribmkt.metadata_units" :disabled="isView"></form-field>
            </div>
          </div>
        </div>
      </div>

      <!-- GRADE DO PRODUTO -->
      <div v-if="item.tipoitem == 'P'">
        <label-title title="Controle de Grade" class="mb-2 mt-2"></label-title>
        <div class="row" v-if="!editaGrade && item.codgradel">
          <form-field reg="codgradel" v-model="item.codgradel" type="select2" col="6" :metadata="metadata.item.codgradel"
            :disabled="true" name="codgradel" :v-errors="errors"
            v-validate="metadata.item.codgradel.validator"></form-field>
          <form-field v-model="item.codgradec" type="select2" col="6" :metadata="metadata.item.codgradec" :disabled="true"
            name="codgradec" :v-errors="errors" v-validate="metadata.item.codgradec.validator"></form-field>
        </div>
        <div class="row" v-if="!editaGrade">
          <div class="col-md-12 col-12">
            <v-button label="Definir Grade No Produto" btdef="true" :disabled="isView" @click="handleHabilitaGrade"
              :tabindex="1"></v-button>
          </div>
        </div>
        <div class="row" v-if="editaGrade">
          <form-field ref="codgradel" v-model="item.codgradel" type="select2" col="6" :metadata="metadata.item.codgradel"
            name="codgradel" :v-errors="errors" v-validate="metadata.item.codgradel.validator"
            :disabled="isView"></form-field>
          <form-field v-model="item.codgradec" type="select2" col="6" :metadata="metadata.item.codgradec" name="codgradec"
            :v-errors="errors" v-validate="metadata.item.codgradec.validator" :disabled="isView"></form-field>
        </div>
        <div class="row" v-if="editaGrade">
          <div class="col-md-12 col-12">
            <v-button label="Aplicar Grade" title="" :nb-btdef="true" @click="handleAplicaGrade"></v-button>
          </div>
        </div>

        <div>
          <div class="mainbox" v-for="(grade, index) in gradelist" v-bind:key="index">
            <!-- <div v-bind:class="[{ 'mark-red': uni.duplicate }]"></div> -->
            <div class="box py-3">
              <div class="row align-items-center">
                <div class="col-md-1 col-12 text-center">
                  <img v-if="grade.parametros && grade.parametros.docs" :src="grade.parametros.docs[0].img"
                    class="mx-auto d-block img-thumbnail" alt="Logotipo" style="max-width: 45px; max-height: 45px;"
                    @click="handleVincularImagem(grade)">
                  <i v-else class="fa fa-camera mx-auto d-block" style="font-size: 25px; color: silver; cursor: pointer"
                    @click="handleVincularImagem(grade)"></i>
                </div>
                <div class="col-md-2 col-12">
                  <span v-if="grade.corlinha" class="current-color" :style="'background-color: ' + grade.corlinha"></span>
                  <span class="lbl-title-produto"> {{ grade.descricaolinha }} </span>
                </div>
                <div class="col-md-2 col-12">
                  <span v-if="grade.corcoluna" class="current-color"
                    :style="'background-color: ' + grade.corcoluna"></span>
                  <span class="lbl-title-produto"> {{ grade.descricaocoluna }} </span>
                </div>
                <form-field v-model="grade.codbarras" type="text" col="2" :metadata="metadata.item.codbarras"
                  :disabled="isView"></form-field>
                <div class="col-md-3 col-12">
                  <input-switch type="success" label="Ativo?" v-model="grade.ativo" value-checked="S"
                    value-unchecked="N"></input-switch>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- <div class="row col">
                <grade :params="{view: false, coditem: item.coditem}"></grade>
            </div> -->
      </div>
      <!-- FIM GRADE DO PRODUTO -->
    </div>

    <div class="nb-modal-mask" v-if="showGruestForm">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
        <div class="modal-content">
          <div class="modal-body">
            <gruest-form crud="ins" @closeform="closeGruestForm"></gruest-form>
          </div>
        </div>
      </div>
    </div>

    <div class="nb-modal-mask" v-if="showUnimedForm">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
        <div class="modal-content">
          <div class="modal-body">
            <unimed-form crud="ins" @closeform="closeUnimedForm"></unimed-form>
          </div>
        </div>
      </div>
    </div>

    <div class="nb-modal-mask" v-if="showDepoForm">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
        <div class="modal-content">
          <div class="modal-body">
            <depo-form crud="ins" @closeform="closeDepoForm"></depo-form>
          </div>
        </div>
      </div>
    </div>

    <anexos-selecionar-form v-if="showAnexosForm"
      :params="{ ref: 'item', chaveref: item.coditem, title: item.descricao, showform: true }"
      @removeform="removeAnexosForm" @saveform="saveAnexosForm" @closeform="closeAnexosForm"></anexos-selecionar-form>

  </div>
</template>

<script>

import { SysVars } from '../main'
import { apiORDS, apiORDSpost, apiORDSdelete, apiValidaLimitePlano } from '../shared/api-functions'
import GruestForm from './gruest-form'
import DepoForm from './depo-form'
import UnimedForm from './unimed-form'
import grade from '../components/grade'
import AnexosSelecionarForm from '../components/anexos-selecionar-form'
import validbarcode from 'barcode-validator'
import Tourguide from 'tourguidejs';

export default {
  props: {
    index: '',
    crud: '',
    importXml: {},
    descricao: '',
  },

  data() {
    return {
      lCrud: '',
      crudText: '',
      item: { ...this.$store.getters.getEntities.item },
      pauta: [], //tabela de pauta do item  {...this.$store.getters.getEntities.pauta}
      itemum: [], //unidades de medida do item {...this.$store.getters.getEntities.itemum}
      itemkit: [], //items que compõem o kit
      itemcatmkt: [], //unidades de medida do item {...this.$store.getters.getEntities.itemcatmkt}
      metadata: { ...this.$store.getters.getEntities.metadata },
      errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
      showFormImport: false,
      showGruestForm: false,
      showFamitForm: false,
      showFamicomForm: false,
      showUnimedForm: false,
      showGrucomForm: false,
      showDepoForm: false,
      showProdPerigoso: false,
      showDadosUni: false,
      showKitForm: false,
      showOutrasInf: false,
      showPauta: false,
      showInfEst: false,
      showDadosMarketplace: false,
      showDadosDimensoes: false,
      showDadosAtributosMercadoLivre: false,
      showAnexosForm: false,
      showAtributo: false,
      showCompItens: false,
      atributosmkt: [],
      categoriesAttributes: [],

      formatoTela: 'normal', //normal, forcaVendas, importacaonfe


      editaGrade: false,
      codgradel_bk: null,
      codgradec_bk: null,
      gradelist: [],
      gradeLinha: {},
      gradeColuna: {},

      itemgrade: null,
      complementos_descricao: {},
      atributo: {},
      atributos: {
        loja: {
          complementos_descricao: []
        }
      },
      indiceUpdate: null,
      iconOptions: [
        { text: 'fa-file-text-o', selected: false },
        { text: 'fa-info-circle', selected: false },
        { text: 'fa-comments', selected: false },
        { text: 'fa-cog', selected: false },
        { text: 'fa-heart-o', selected: false }
      ],
      classIconCheck: '',
      complementos: [],

      hasManyItem: false,
      steps: [
        {
          "selector": "",
          "step": 1,
          "title": `Vamos começar!`,
          "content": "Vamos te guiar passo a passo por todo o processo de cadastro de produto.</br></br><a href='javascript:void(0)' class='btn btn-sm btn-danger text-white' onclick='window.dispatchEvent(new CustomEvent(\"desativar-guia\"))'>Não mostrar este guia</a>",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#codigo",
          "step": 2,
          "title": `Codigo`,
          "content": "Informe o Código do produto.",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#descricao",
          "step": 3,
          "title": `Descrição`,
          "content": "Informe o Descrição do produto.",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#ncm",
          "step": 4,
          "title": `Ncm`,
          "content": "Informe o ncm do produto.",
          // "image": "https://somehost.com/image.jpeg"
        },

      ],


    }
  },

  computed: {
    itemComMovimento: function () {
      return this.item.item_com_movimento == 'S'
    },

    informaFCI: function () {
      return this.item.orimerc == '3' || this.item.orimerc == '5' || this.item.orimerc == '8'
      // return this.item.orimerc == '1' || this.item.orimerc == '2' || this.item.orimerc == '3' ||
      //        this.item.orimerc == '5' || this.item.orimerc == '6' || this.item.orimerc == '7' ||
      //        this.item.orimerc == '8'
    },

    orimerc: function () {
      return this.item.orimerc
    },

    catmktList: function () {
      return this.$store.getters.getCatmktList
    },

    administrador: function () {
      return SysVars.usuarioAdministrador
    },

    isView: function () {
      return (this.crud == SysVars.crudView)
    },

    permissaoExcluir: function () {
      return (this.crud != SysVars.crudView && this.administrador) && (this.formatoTela != 'forcaVendas')
    },
    showGuia: function () {
      return SysVars.guia
    },
    appLoja: function () {
      return SysVars.appLoja
    }


  },

  watch: {
    orimerc: function (value) {
      //ATRIBUI ALIQUOTA 4% QUANDO ORIGEM FOR IMPORTADO
      if (value === '1') {
        this.item.aicm = 4
      } else {
        this.item.aicm = 0
      }
    },
    'item.tipoitem': function (value) {
      this.metadata = JSON.parse(JSON.stringify(this.$store.getters.getEntities.metadata))

      this.metadata.item.ncm.validator.required = true
      this.metadata.item.cservico.validator.required = false
      if (value == 'S') {
        this.metadata.item.ncm.validator.required = false
        this.metadata.item.cservico.validator.required = true
      }


    },
  },

  methods: {
    handleDeleteAtributo(i) {
      this.atributos.loja.complementos_descricao.splice(i, 1)
      this.item.atributos = this.atributos
    },
    handleEditAtributo(i) {
      this.atributo = { ...this.atributos.loja.complementos_descricao[i] }
      this.indiceUpdate = i
      this.showModalAtributo();
    },
    handleSelectIcon(icon) {
      this.atributo.icone = icon.text
      this.iconOptions.forEach(e => e.selected == true ? e.selected = false : false)
      const index = this.iconOptions.indexOf(icon)
      this.iconOptions[index].selected = true
    },
    handleSaveAtributo() {
      console.log(this.indiceUpdate)
      if (this.indiceUpdate >= 0 && this.indiceUpdate !== null) {
        this.atributos.loja.complementos_descricao[this.indiceUpdate] = this.atributo;

      }
      else {
        this.atributos.loja.complementos_descricao.push(this.atributo);

      }

      this.indiceUpdate = null

      this.item.atributos = { ...this.atributos }
      this.closeModalAtributo();


    },
    showModalAtributo() {
      this.showAtributo = true
    },
    closeModalAtributo() {
      this.atributo = ''
      this.showAtributo = false

    },
    handleNewAtributo() {
      this.atributo = { conteudo: '', icone: '', titulo: '', ativo: false }
      this.showModalAtributo();
    },
    handleNewComplemento() {
      const complemento = { descricao: '', ativo: true }
      this.complementos.unshift(complemento)
    },
    handleDeleteComp(index) {
      this.complementos.splice(index, 1);
    },
    removeAnexosForm() {
      for (var x = 0; x < this.gradelist.length; x++) {
        if (this.gradelist[x].codlinha == this.itemgrade.codlinha) {
          if (!this.gradelist[x].parametros)
            this.gradelist[x].parametros = {}
          this.gradelist[x].parametros.docs = null
        }
      }
      this.showAnexosForm = false;
    },

    saveAnexosForm(param) {
      for (var x = 0; x < this.gradelist.length; x++) {
        if (this.gradelist[x].codlinha == this.itemgrade.codlinha) {
          if (!this.gradelist[x].parametros)
            this.gradelist[x].parametros = {}
          this.gradelist[x].parametros.docs = []
          this.gradelist[x].parametros.docs.push(param)
        }
      }
      this.showAnexosForm = false;
    },

    closeAnexosForm() {
      this.itemgrade = null;
      this.showAnexosForm = false;
    },

    handleVincularImagem(itemgrade) {
      this.itemgrade = itemgrade;
      this.showAnexosForm = true;
    },

    closeForm() {
      if (this.$route.params.id == 'novo')
        this.$router.go(-1)
      else
        this.$emit('closeform')
    },

    closeGruestForm(id) {
      if (id) this.item.codgruest = id
      this.showGruestForm = false
    },

    closeGrucomForm(id) {
      if (id) this.item.codgrucom = id
      this.showGrucomForm = false
    },

    closeFamicomForm(id) {
      if (id) this.item.codfamicom = id
      this.showFamicomForm = false
    },

    closeFamiForm(id) {
      if (id) this.item.codfami = id
      this.showFamiForm = false
    },

    closeUnimedForm(id) {
      if (id) this.item.coduni = id
      this.showUnimedForm = false
    },

    closeDepoForm(id) {
      if (id) this.item.coddepo = id
      this.showDepoForm = false
    },

    handleSave() {
      //BOTAO SALVAR
      this.$validator.validateAll().then(isValid => {
        //AQUI EFETUA VALIDACAO NA TABELA DE PAUTA E NA UNIDADE DE MEDIDA

        // console.log(this.errors)

        let lErro = false
        if (this.pautaValidate()) {
          lErro = true
        }
        if (this.uniValidate()) {
          lErro = true
        }
        if (this.catmktValidate()) {
          lErro = true
        }
        if (this.itemKitValidate()) {
          lErro = true
        }
        if (this.itemGTINValidate()) {
          lErro = true
        }
        if (!isValid || lErro) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else {
          this.apiPost()
        }
      })
    },

    handleAdicionaPauta() {
      //adiciona nova linha na tabela de pauta
      var p = { ...this.$store.getters.getEntities.pauta }
      this.pauta.push(p);
    },

    handleDeletePauta(index) {
      //exclui linha da tabela de pauta
      this.pauta.splice(index, 1)
    },

    handleAdicionaUni() {
      //adiciona nova linha na tabela de unidade de medida do item
      var p = { ...this.$store.getters.getEntities.itemum }
      this.itemum.push(p);
    },

    handleDeleteUni(index) {
      //exclui linha da tabela de unidades de medida do item
      this.itemum.splice(index, 1)
    },

    handleAdicionaItem() {
      //adiciona nova linha na tabela de unidade de medida do item
      var i = { ...this.$store.getters.getEntities.itemkit }
      this.itemkit.push(i);
    },

    handleDeleteItem(index) {
      //exclui linha da tabela de unidades de medida do item
      this.itemkit.splice(index, 1)
    },

    handleAdicionaCatmkt() {
      //adiciona nova linha na tabela de categoria do item
      var p = { ...this.$store.getters.getEntities.itemcatmkt }
      this.itemcatmkt.push(p);
    },

    handleCategoriesAttributes(data) {
      let test = {}

      this.categoriesAttributes = [];

      for (var x = 0; x < data.length; x++) {
        test = data[x];
        if (test.id != 'BRAND') {
          let valor = {
            id: test.id,
            value_type: test.value_type,
            name: test.name,
            value_id: "",
            value_name: "",
            metadata: {
              decimals: 2,
              fieldname: test.id,
              help: test.name,
              label: test.name,
              length: 255,
              options: [],
              pk: "False"
            },
            metadata_units: {
              decimals: 2,
              fieldname: test.id + "_units",
              help: "",
              label: "",
              length: 255,
              options: [],
              pk: "False"
            }

          }

          let atributo = {
            id: "",
            value_id: "",
            value_name: ""
          }
          for (var y = 0; y < this.atributosmkt.length; y++) {
            if (this.atributosmkt[y].id == test.id) {
              atributo = this.atributosmkt[y];
            }
          }

          if (test.value_type == 'string') {
            valor.metadata.length = test.value_max_length;
            if (atributo) {
              valor.value_name = atributo.value_name;

            }
          }
          if (test.value_type == 'list') {
            if (atributo) {
              valor.value_id = atributo.value_id;
            }
            for (var y = 0; y < test.values.length; y++) {
              valor.metadata.options.push({ id: test.values[y].id, text: test.values[y].name });
            }
          }
          if (test.value_type == 'boolean') {
            if (atributo) {
              valor.value_id = atributo.value_id;
            }
            for (var y = 0; y < test.values.length; y++) {
              valor.metadata.options.push({ id: test.values[y].id, text: test.values[y].name });
            }
          }
          if (test.value_type == 'number') {
            valor.metadata.length = test.value_max_length;
            if (atributo) {
              valor.value_name = atributo.value_name;
            }
          }
          if (test.value_type == 'number_unit') {

            for (var y = 0; y < test.allowed_units.length; y++) {
              valor.metadata_units.options.push({ id: test.allowed_units[y].id, text: test.allowed_units[y].name });
              if ((atributo) && (atributo.value_name.includes(' ' + test.allowed_units[y].id))) {
                valor.value_id = test.allowed_units[y].id;
                valor.value_name = atributo.value_name.replace(' ' + test.allowed_units[y].id, "");
              }
            }
          }

          this.categoriesAttributes.push(valor);
        }
      }

    },

    handleCatmkt() {
      this.showDadosAtributosMercadoLivre = false;

      let test = {}
      let catmkt = {}

      for (var x = 0; x < this.itemcatmkt.length; x++) {
        test = this.itemcatmkt[x];
        for (var y = 0; y < this.catmktList.length; y++) {
          if (test.codcatmkt == this.catmktList[y].codcatmkt) {
            if (this.catmktList[y].marketplacecatmkt == 2) {
              this.showDadosAtributosMercadoLivre = true;
              catmkt = this.catmktList[y]
            }
          }
        }

      }

      this.categoriesAttributes = [];

      if (this.showDadosAtributosMercadoLivre) {
        jQuery.get("https://api.mercadolibre.com/categories/" + catmkt.altern + "/attributes", this.handleCategoriesAttributes);
      }
    },

    handleDeleteCatmkt(index) {
      //exclui linha da tabela de categoria do item
      this.itemcatmkt.splice(index, 1)
    },

    itemValidate() {
      return false
    },

    itemGTINValidate() {
      let result = false

      this.errmessages = []

      if ((this.item.codbarras) && (this.item.codbarras.length > 0) && (!validbarcode(this.item.codbarras))) {
        this.errmessages.push("Código GTIN inválido!")
        result = true
      }
      // console.log('itemgtin validate ' + result)
      return result

    },


    uniValidate() {
      //checa se foi digitado unidade de medida repetida para o item
      //compara também se a unidade digitada é igual à unidade principal do item
      let test = {}
      //cria novo objeto array para fazer a veiricacao de duplicidades
      let uniArr = this.itemum.map(function (obj) {
        return { uni: obj.uni }
      })
      //efetua a verificacao da duplicidade
      let duplicate = false
      let validate = ''
      for (var x = 0; x < uniArr.length; x++) {
        test = uniArr[x]
        this.$set(this.itemum[x], 'duplicate', false)
        if (this.itemum[x].uni == this.item.uni) {
          this.itemum[x].duplicate = true
          duplicate = true
        }
        if (uniArr.findIndex(obj => obj.uni == test.uni) < x) {
          this.itemum[x].duplicate = true
          duplicate = true
        }
        if (this.itemum[x].fatoruni == null || this.itemum[x].fatoruni == 0) {
          validate = 'Obrigatório informar ' + this.metadata.itemum.fatoruni.label
          this.$set(this.itemum[x], 'validate', validate)
          return true
        } else {
          this.$set(this.itemum[x], 'validate', '')
        }
      }
      // console.log('uni validate ' + duplicate)
      return duplicate
    },

    itemKitValidate() {
      //checa se foi digitado unidade de medida repetida para o item
      //compara também se a unidade digitada é igual à unidade principal do item
      let test = {}
      //cria novo objeto array para fazer a veiricacao de duplicidades
      let kitArr = this.itemkit.map(function (obj) {
        return { coditem: obj.coditem }
      })
      //efetua a verificacao da duplicidade
      let duplicate = false
      let validate = ''
      for (var x = 0; x < kitArr.length; x++) {
        test = kitArr[x]
        this.$set(this.itemkit[x], 'duplicate', false)
        if (this.itemkit[x].coditem == this.item.coditem) {
          this.itemkit[x].duplicate = true
          duplicate = true
        }
        if (kitArr.findIndex(obj => obj.coditem == test.coditem) < x) {
          this.itemkit[x].duplicate = true
          duplicate = true
        }
        if (this.itemkit[x].qt == null || this.itemkit[x].qt == 0) {
          validate = 'Obrigatório informar quantidade'
          this.$set(this.itemkit[x], 'validate', validate)
          return true
        } else {
          this.$set(this.itemkit[x], 'validate', '')
        }
      }

      // console.log('itemkit validate ' + duplicate)
      return duplicate
    },

    pautaValidate() {
      //checa se foi digitado tabela de pauta repetida para o item
      let test = {}
      //cria novo objeto array para fazer a veiricacao de duplicidades
      let pautaArr = this.pauta.map(function (obj) {
        return { ufdest: obj.ufdest, dtinicio: obj.dtinicio }
      })
      //efetua a verificacao da duplicidade
      let duplicate = false
      let validate = ''
      for (var x = 0; x < pautaArr.length; x++) {
        test = pautaArr[x]
        this.$set(this.pauta[x], 'duplicate', false)
        if (pautaArr.findIndex(obj => obj.ufdest == test.ufdest && obj.dtinicio == test.dtinicio) < x) {
          this.pauta[x].duplicate = true
          duplicate = true
        }
        if (this.pauta[x].pautaicm == null && this.pauta[x].pautaicmst == null) {
          validate = 'Obrigatório informar ' + this.metadata.pauta.pautaicm.label + ' ou ' + this.metadata.pauta.pautaicmst.label
          this.$set(this.pauta[x], 'validate', validate)
        } else {
          this.$set(this.pauta[x], 'validate', '')
        }
      }
      // console.log('pauta validate ' + duplicate)
      return duplicate
    },

    catmktValidate() {
      //checa se foi digitado unidade de medida repetida para o item
      //compara também se a unidade digitada é igual à unidade principal do item
      let test = {}
      //cria novo objeto array para fazer a verificacao de duplicidades
      let codcatmktArr = this.itemcatmkt.map(function (obj) {
        return { codcatmkt: obj.codcatmkt }
      })
      //efetua a verificacao da duplicidade
      let duplicate = false
      let validate = ''
      for (var x = 0; x < codcatmktArr.length; x++) {
        test = codcatmktArr[x]
        this.$set(this.itemcatmkt[x], 'duplicate', false)
        if (codcatmktArr.findIndex(obj => obj.codcatmkt == test.codcatmkt) < x) {
          this.itemcatmkt[x].duplicate = true
          duplicate = true
        }
        this.$set(this.itemcatmkt[x], 'validate', '')
      }
      // console.log('catmkt validate ' + duplicate)
      return duplicate
    },

    inicializaItem() {
      this.item.stitem = 'A'
      this.item.tipoitem = 'P'
      this.item.tipoestoque = 'N'
      this.item.tipoproduto = '04'
      this.item.controlalocal = 'N'
      this.item.escalaprod = '0'
      this.item.ipiitem = 'N'
      this.item.icmitem = 'T'
      this.item.issitem = 'N'
      this.item.stpis = '01'
      this.item.stcofins = '01'
      this.item.orimerc = '0'
      this.item.uni = 'UN'
      this.item.incentfiscaliss = 'N'

      this.item.dtcadastro = this.$getDate()
      // this.item.dtcadastro = ''
    },

    async loadData() {
      //carrega o item para alteracao ou visualizacao
      await this.$store.dispatch('loadItem', { id: this.item.coditem })
      await this.$store.dispatch('loadCatmkt', {})

      if (this.$store.getters.getItem) {
        this.item = { ...this.$store.getters.getItem[0] }
        if (this.item.pauta && this.item.pauta.length) {
          this.pauta = this.item.pauta
        }
        if (this.item.itemum && this.item.itemum.length) {
          this.itemum = this.item.itemum
        }
        if (this.item.itemkit && this.item.itemkit.length) {
          this.itemkit = this.item.itemkit
        }
        if (this.item.itemgrade && this.item.itemgrade.length) {
          this.gradelist = this.item.itemgrade
          for (var x = 0; x < this.gradelist.length; x++) {
            if (this.gradelist[x].parametros) {
              this.gradelist[x].parametros = JSON.parse(this.gradelist[x].parametros)
            }
          }
        }
        if (this.item.itemcatmkt && this.item.itemcatmkt.length) {
          this.itemcatmkt = this.item.itemcatmkt
        }
        if (this.item.atributosmkt) {
          this.atributosmkt = JSON.parse(this.item.atributosmkt);
        }
        if (this.item.atributos || this.item.atributos == null) {

          this.atributos = JSON.parse(this.item.atributos);

          if (this.atributos == null) {
            this.atributos = {}
          }
        }

        if (!this.atributos.hasOwnProperty('loja')) {
          this.atributos.loja = {
            complementos_descricao: []
          }
        }

        if (!this.atributos.hasOwnProperty('obs')) {
          this.atributos.obs = {
            complementos: []
          }
        }

        this.complementos = this.atributos.obs.complementos;

        this.lCrud = SysVars.crudU;
        this.crudText = this.$crudText(this.lCrud)

      } else {
        this.inicializaItem()
        //QUANDO FOR UMA INCLUSAO DE ITEM PELA IMPORTACAO DE XML DE NFE, ATRIBUI OS CAMPOS DO XML PARA O NOVO ITEM
        if (this.importXml) {
          this.item.coditem = this.importXml.codigoxml
          this.item.descricao = this.importXml.descricao
          this.item.codbarras = this.importXml.cean
          this.item.cest = this.importXml.cest
          this.item.ncm = this.importXml.ncm
          this.item.orimerc = this.importXml.orimerc
          //ATRIBUI O TIPO DE PRODUTO CONFORME TIPO DE NATUREZA SELECIONADA NA IMPORTACAO DO XML
          if (this.importXml.nates.finentrada == '1') {
            this.item.tipoproduto = '01' //materia prima
          } else
            if (this.importXml.nates.finentrada == '2') {
              this.item.tipoproduto = '00' //mercadoria para revenda
            } else
              if (this.importXml.nates.finentrada == '3') {
                this.item.tipoproduto = '07' //uso e consumo
              } else
                if (this.importXml.nates.finentrada == '4') {
                  this.item.tipoproduto = '08' //ativo
                } else {
                  this.item.tipoproduto = '04' //acabado
                }
        }
      }

      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    async apiDelete(del) {
      //efetua a exclusao do item
      if (confirm("Confirma a exclusão?")) {
        var modulo = 'cg/item/' + this.item.coditem
        var sendData = {}

        const data = await apiORDSdelete(this.$store, modulo)
        this.$erpToastSuccess('Item excluído.')
        this.closeForm()
      }
    },

    async apiPost() {
      //efetua a gravacao do item

      var modulo = 'cg/item/'
      var sendData = {}

      this.item.pauta = this.pauta
      this.item.itemum = this.itemum
      this.item.itemkit = this.itemkit
      this.item.itemgrade = this.gradelist
      this.item.itemcatmkt = this.itemcatmkt

      this.item.atributos = this.atributos

      if (!this.item.atributos.obs) {
        this.item.atributos.obs = {}
      }

      this.item.atributos.obs.complementos = this.complementos

      this.atributosmkt = [];
      for (var x = 0; x < this.categoriesAttributes.length; x++) {
        let test = this.categoriesAttributes[x];
        let valor = {
          id: test.id,
          value_id: test.value_id,
          value_name: test.value_name
        }
        if (test.value_type == 'number_unit') {
          valor.value_name = valor.value_name + ' ' + valor.value_id;
          valor.value_id = "";
        }
        if ((valor.value_id) || (valor.value_name))
          if ((valor.value_id.trim() != "") || (valor.value_name.trim() != ""))
            this.atributosmkt.push(valor);
      }
      this.item.atributosmkt = this.atributosmkt

      sendData = { item: this.item }

      let metodo = 'post'
      let update = false
      if (this.lCrud != SysVars.crudI) {
        metodo = 'put'
        update = true
      }

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      if (data.errmessages) {
        this.errmessages = data.errmessages
        this.$erpToastError('Alguns erros precisam ser corrigidos.')
      } else {
        if (update) {
          this.$erpToastSuccess('O item foi alterado com sucesso')
        } else {
          this.$erpToastSuccess('O item foi inserido com sucesso')
        }
        this.errmessages = {}
        if (this.$route.params.id !== 'novo') {
          this.$emit('closeform', data.items[0])
        } else {
          this.$router.push('/itemlist')
        }

      }

    },

    handleIncluir(pTipo) {
      //exibe tela de cadastro
      if (this.isView) {
        return
      }

      if (pTipo === 'gruest') {
        this.showGruestForm = true
      }

      if (pTipo === 'depo') {
        this.showDepoForm = true
      }

      if (pTipo === 'grucom') {
        this.showGrucomForm = true
      }

      if (pTipo === 'fami') {
        this.showFamiForm = true
      }

      if (pTipo === 'famicom') {
        this.showFamicomForm = true
      }

      if (pTipo === 'uni') {
        this.showUnimedForm = true
      }
    },

    //
    //
    //TRATAMENTO DA GRADE
    //
    //

    handleHabilitaGrade() {
      if (this.item.possuimovimento) {
        this.$erpToastError('Não é permitido definir grade para este produto')
        return
      }
      this.editaGrade = true
      this.codgradel_bk = this.item.codgradel
      this.codgradec_bk = this.item.codgradec
      this.$nextTick(function () {
        this.$refs.codgradel.focus()
      })
    },

    async handleAplicaGrade() {
      //A GRADE DE LINHAS É OBRIGATORIA

      this.editaGrade = false

      this.gradeLinha = null
      this.gradeColuna = null


      //CARREGA OS OBJETOS GRADELINHA, GRADECOLUNA PARA INICIAR A MONTAGEM DA GRADE
      if (this.item.codgradel) {
        await this.$store.dispatch('loadGrade', { id: this.item.codgradel })
        if (this.$store.getters.getGrade) {
          this.gradeLinha = { ...this.$store.getters.getGrade }
          // // this.gradeLinha.valores = JSON.parse(this.$store.getters.getGrade.valores)
          // this.gradeLinha.gradeit = this.$store.getters.getGrade.gradeit
        }
      }
      if (this.item.codgradec) {
        await this.$store.dispatch('loadGrade', { id: this.item.codgradec })
        if (this.$store.getters.getGrade) {
          this.gradeColuna = { ...this.$store.getters.getGrade }
          // // this.gradeColuna.valores = JSON.parse(this.$store.getters.getGrade.valores)
          // this.gradeColuna.gradeit = this.$store.getters.getGrade.gradeit
        }
      }

      this.gradelist = []
      let itemGrade = {}

      for (var x = 0; x < this.gradeLinha.gradeit.length; x++) {
        if (this.gradeColuna && this.gradeColuna.gradeit.length > 0) {
          for (var y = 0; y < this.gradeColuna.gradeit.length; y++) {
            itemGrade.codlinha = this.gradeLinha.gradeit[x].codgradeit
            itemGrade.descricaolinha = this.gradeLinha.gradeit[x].descricao
            itemGrade.codcoluna = this.gradeColuna.gradeit[y].codgradeit
            itemGrade.descricaocoluna = this.gradeColuna.gradeit[y].descricao
            itemGrade.coditem = ''
            itemGrade.codbarras = ''
            itemGrade.precovenda = 0
            itemGrade.ativo = 'S'
            this.gradelist.push({ ...itemGrade })
          }
        } else {
          itemGrade.codlinha = this.gradeLinha.gradeit[x].codgradeit
          itemGrade.descricaolinha = this.gradeLinha.gradeit[x].descricao
          itemGrade.codcoluna = null
          itemGrade.descricaocoluna = null
          itemGrade.coditem = ''
          itemGrade.codbarras = ''
          itemGrade.precovenda = 0
          itemGrade.ativo = 'S'
          this.gradelist.push({ ...itemGrade })
        }
      }

    },

    async hasGrid(coditem) {
      const data = await apiORDS(this.$store.getters.urlOrds + 'cg/item/' + coditem, null)
      this.itemkit.filter(i => {
        if (data.items[0].isgrade === 'S') {
          if (i.coditem === coditem)
            this.$set(i, 'hasGrid', data.items[0].isgrade)
          return
        }
        if (i.coditem === coditem) {
          i.coditemgrade = null
          if (i.hasGrid)
            delete i.hasGrid
        }
      })
      console.log(this.itemkit)
    },

  },

  components: {
    DepoForm, UnimedForm, GruestForm, grade, AnexosSelecionarForm, Tourguide

  },

  beforeCreate() {

  },

  async mounted() {
    //validacao para inclusao de novo produto
    if (this.lCrud == SysVars.crudI) {
      const isValid = await apiValidaLimitePlano(this, 'produtos')
      if (!isValid)
        this.closeForm()
      else {
        if (this.showGuia) {
          const filter = '{"codigo":{"$ne":"TESTE"}}'
          let params = { filter: filter }
          await this.$store.dispatch('loadItemList', params)
          this.hasManyItem = (this.$store.getters.getItemList.length >= 1)
          if (this.showGuia && !this.hasManyItem) {
            var tourguide = new Tourguide({
              steps: this.steps
            });

            tourguide.start();
          }
        }
      }
    }
  },

  created() {
    this.lCrud = this.crud
    if (this.$route.params && this.$route.params.id == 'novo')
      this.lCrud = SysVars.crudI

    this.crudText = this.$crudText(this.lCrud)

    if (this.importXml) {
      this.item.coditem = this.importXml.codigoxml
    } else {
      this.item.coditem = this.index
    }


    if (this.lCrud == SysVars.crudI) {
      this.inicializaItem()
      if (this.descricao) {
        this.item.descricao = this.descricao //INCLUSAO PELO INPUT-ITEM
      }
    } else {
      this.loadData()
    }

    this.handleCatmkt();

    if (SysVars.appNFe) {

    } else
      if (SysVars.appForcaVendas) {
        this.formatoTela = 'forcaVendas'
      }

    if (this.importXml) {
      this.formatoTela = 'importacaonfe'
    }

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
      if (this.crud == SysVars.crudI)
        this.$refs.codigo.focus()
    })

  }

}

</script>

<style>
.current-color {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.btn-icon {
  background: transparent;
  font-weight: bold;
}

.iconSelected {
  background: rgb(201, 201, 201);
  border: 1px solid rgb(174, 174, 174);
}

.btn-icon:focus {

  outline: none;
}</style>
tyle>
tyle>



// WEBPACK FOOTER //
// src/forms/item-form.vue